import axios, { AxiosPromise } from 'axios';
import { ProcessoDigitalDTO } from 'common/type/ProcessoDigitalDTO';

export const findById = (id: string): AxiosPromise<ProcessoDigitalDTO> => {
  return axios.get(`/compras-api/api/processos-digitais/${id}`);
};
